import React, { ReactNode, useState, useRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import ReactPlayer from 'react-player';

import { Modal } from '../../common';

import './BannerAdItem.scss';

export interface IBannerAdItemProps {
  image: any;
  title: string;
  content: string | ReactNode;
  linkPath?: string;
  videoUrl?: string;
}

const BannerAdItem = ({
  linkPath = '',
  image,
  title,
  content,
  videoUrl = '',
}: IBannerAdItemProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const modalTriggerRef = useRef<HTMLButtonElement | null>(null);
  const [videoLoaded, setVideoLoaded] = useState<boolean>(false);

  const getAdImage = (linkPath: string, videoUrl: string, image: ReactNode) => {
    if (linkPath) {
      return (
        <a href={linkPath} target="_blank" rel="noreferrer">
          {image}
        </a>
      );
    }

    if (videoUrl) {
      return (
        <button
          ref={modalTriggerRef}
          onClick={() => setShowModal(true)}
          title="Play Video"
        >
          {image}
        </button>
      );
    }

    return image;
  };
  return (
    <>
      <article className={`banner-ad-item ${title.split(' ').join('-')}`}>
        {getAdImage(linkPath, videoUrl, image)}
        <h3 className="banner-ad-item__title">{title}</h3>
        {typeof content === 'string' ? (
          <p className="banner-ad-item__description">{content}</p>
        ) : (
          content
        )}
      </article>
      <AnimatePresence>
        {showModal && (
          <Modal
            className="banner-ad-item__video-modal"
            isOpen={showModal}
            type="dialog"
            focusTrapWatchList={[videoLoaded]}
            onClose={() => {
              setShowModal(false);
              modalTriggerRef?.current?.focus();
            }}
            ariaLabel="Max Promotional Video"
          >
            <ReactPlayer
              width="100%"
              url={videoUrl}
              playing={true}
              playsinline={true}
              controls={true}
              onPlay={() => setVideoLoaded(true)}
            />
          </Modal>
        )}
      </AnimatePresence>
    </>
  );
};

export default BannerAdItem;
